import { DashboardShell } from "@/components/dashboard-shell"
import { DealsView } from "@/components/deals/deals-view"
import { createFileRoute } from "@tanstack/react-router";
import {
  RouteLoading,
  ToolbarSkeleton,
  KanbanLoadingSkeleton,
} from "@/components/route-loading";

export const Route = createFileRoute("/deals/")({
  component: DealsPage,
  head: () => ({ meta: [{ title: "Deals" }] }),
  pendingComponent: DealsPending,
});

function DealsPage() {
  return (
    <DashboardShell>
      <DealsView />
    </DashboardShell>
  )
}

// Shown while this route's chunk (and the ReUI components in it)
// downloads. Was src/app/deals/loading.tsx.
function DealsPending() {
  return (
    <RouteLoading>
      <ToolbarSkeleton />
      <KanbanLoadingSkeleton />
    </RouteLoading>
  );
}
